/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 8/23/2023
 */

import React, { useState, useEffect } from "react"
import Select from "react-select"
import api from "../../../base/services/AuthApi"
import { FormControl } from "@mui/material"

const UserRoleDropdown = ({ selectRole, handleOnChange }) => {
  const [data, setData] = useState([])

  let apprvConfig = {
    headers: {
      Action: "VAPR",
      "Page-Page-OffSet": 0,
      "Page-Size": 500,
      "Sort-Field": "roleId",
      "Sort-Order": "asc",
    },
  }

  useEffect(() => {
    const fetchData = () => {
      api
        .get("/role/permissions", apprvConfig)
        .then((res) => {
          setData(res.data.dataList[0].rolePerms)
        })
        .catch((error) => {
          console.log(error)
        })
    }
    fetchData()
  }, [])

  // Selector
  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: "10px",
    }),
  }

  const options = data.map((item) => ({
    value: item.role,
    label: item.role,
    target: { name: "userRole", value: item.role },
  }))

  return (
    <div>
      <p
        style={{
          fontSize: "12px",
          position: "relative",
          top: "-12px",
          left: "10px",
          background: "#fff",
          width: "130px",
          paddingLeft: "5px",
          zIndex: 100,
        }}
      >
        Select User Role
      </p>
      <FormControl
        required
        sx={{
          minWidth: 400,
          zIndex: 90,
          position: "relative",
          top: "-37px",
          height: 0,
        }}
        size="medium"
      >
        <Select
          options={options}
          value={options.find((option) => option.value === selectRole)}
          onChange={handleOnChange}
          styles={customStyles}
        />
      </FormControl>
    </div>
  )
}

export default UserRoleDropdown
